import {
    SpecificationContext,
    useSpecificationContext
} from './SpecificationContext';
import SpecificationsProvider from './SpecificationProvider';

export { SpecificationContext, useSpecificationContext };
export default SpecificationsProvider;
